// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/severe-icing-detection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/severe-icing-detection/severe-icing-detection.js';

mount([g0]);
